/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSpecification: {
  name: 'specification';
  data: string;
} = {
  name: 'specification',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm8 2H6v16h8V4Zm2 16V4h2v16h-2ZM9 6a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Zm-1 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
